window.leadBrokerUpdate = function leadBrokerUpdate (broker) {
  window.MicroModal.close("broker-modal");
  document.getElementById("broker-id-field").value = broker.id;
  document.getElementById("full-name").innerText = "";
  document.getElementById("full-name").append(broker.full_name);
};
